import '../../vendor/js/nccsticky';

// Link course outline items to lesson sections
(function () {
    const initOutlineNav = () => {
        const outlineRoot = document.querySelector('.sidebar-inner:not(.sticky-dummy) .course-outline');
        if (!outlineRoot) return;

        const courseOutlineLinks = document.querySelectorAll(
            '.sidebar-inner:not(.sticky-dummy) .course-outline a, .mobile-sidebar .course-outline a'
        );

        // Pick the container that exists on this template
        const sectionRoot =
            document.querySelector('.lesson-content') ||
            document.querySelector('.course-page-wrapper') ||
            document;

        const getHeadings = () => sectionRoot.querySelectorAll('h1, h2, h3, h4');

        const normBase = (s) => (s || '')
            .normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/\u00A0/g, ' ')
            .replace(/[\u2018\u2019\u2032]/g, "'").replace(/[\u201C\u201D\u2033\u00AB\u00BB]/g, '"')
            .replace(/[\u2013\u2014]/g, '-').replace(/\s+/g, ' ').trim().toLowerCase();

        const normLoose = (s) => normBase(s)
            .replace(/'s\b/gi, '')                         // Drop possessive 's (after normBase)
            .replace(/['"“”‘’.,:;!?()[\]{}]/g, '');        // Strip remaining punctuation

        const closeMobile = () => {
            const mobile = document.querySelector('.mobile-sidebar.open');
            if (mobile) mobile.classList.remove('open');
        };

        const scrollToEl = (el) => {
            if (!el) return;
            const top = el.getBoundingClientRect().top + window.pageYOffset;
            const direction = window.scrollY >= top ? 'up' : 'down';
            const offset = direction === 'down' ? 28 : 106;
            window.scrollTo({ behavior: 'smooth', top: top - offset });
        };

        // Resolve the element for a given outline link
        const resolveTargetForLink = (link) => {
            // Special cases
            if (link.classList.contains('survey-link')) return document.querySelector('.survey');
            if (link.classList.contains('complete-course-link')) return document.querySelector('.course-footer');

            // Same-page hash (supports absolute URLs)
            const getTargetFromHash = (hash) => {
                if (!hash || hash === '#') return null;
                let id = hash.slice(1);
                try { id = decodeURIComponent(id); } catch (_) { }
                id = id.trim();
                if (!id) return null;
                return document.getElementById(id) ||
                    (window.CSS && CSS.escape ? document.querySelector('#' + CSS.escape(id)) : null);
            };

            const href = link.getAttribute('href') || '';
            let hash = '';
            if (href.startsWith('#')) {
                hash = href;
            } else {
                try {
                    const u = new URL(href, window.location.href);
                    if (u.origin === location.origin && u.pathname === location.pathname) hash = u.hash;
                } catch (_) { }
            }
            const byHash = getTargetFromHash(hash);
            if (byHash) return byHash;

            // Fallback: Text match (base then loose)
            const headings = getHeadings();
            const wantB = normBase(link.textContent);
            const wantL = normLoose(link.textContent);

            // Exact base, exact loose, then includes (both ways)
            let match = Array.from(headings).find(h => normBase(h.textContent) === wantB);
            if (!match) match = Array.from(headings).find(h => normLoose(h.textContent) === wantL);
            if (!match) {
                match = Array.from(headings).find(h => {
                    const tB = normBase(h.textContent);
                    const tL = normLoose(h.textContent);
                    return tB.includes(wantB) || wantB.includes(tB) || tL.includes(wantL) || wantL.includes(tL);
                });
            }
            return match || null;
        };

        // Build link→target pairs (only items that actually resolve)
        const outlinePairs = Array.from(courseOutlineLinks)
            .map(link => ({ link, el: resolveTargetForLink(link) }))
            .filter(x => !!x.el);

        // Keep pairs in DOM order
        outlinePairs.sort((a, b) => {
            const pos = a.el.compareDocumentPosition(b.el);
            if (pos & Node.DOCUMENT_POSITION_FOLLOWING) return -1;   // a before b
            if (pos & Node.DOCUMENT_POSITION_PRECEDING) return 1;    // a after b
            return 0;
        });

        const elToLinks = new Map();
        outlinePairs.forEach(({ link, el }) => {
            const arr = elToLinks.get(el) || [];
            arr.push(link);
            elToLinks.set(el, arr);
        });

        // Use pairs in the click handler
        courseOutlineLinks.forEach(link => {
            link.addEventListener('click', (e) => {
                const pair = outlinePairs.find(p => p.link === link);

                // If this is a same-page hash, always prevent default to avoid jump-to-top
                const href = link.getAttribute('href') || '';
                if (href.startsWith('#') || (() => {
                    try { const u = new URL(href, location.href); return u.origin === location.origin && u.pathname === location.pathname && u.hash; }
                    catch (_) { return false; }
                })()) e.preventDefault();

                if (pair && pair.el) {
                    scrollToEl(pair.el);
                    closeMobile();

                    // Immediately reflect active state for the target
                    courseOutlineLinks.forEach(l => l.classList.remove('active'));
                    (elToLinks.get(pair.el) || [link]).forEach(l => l.classList.add('active'));

                    requestAnimationFrame(updateActive); // Make snappier for fast devices
                    return;
                }

                // Fallback if pair didn’t resolve (should be rare, but just in case)
                const el = resolveTargetForLink(link);
                if (el) {
                    scrollToEl(el);
                    closeMobile();

                    courseOutlineLinks.forEach(l => l.classList.remove('active'));
                    (elToLinks.get(el) || [link]).forEach(l => l.classList.add('active'));

                    requestAnimationFrame(updateActive); // Make snappier for fast devices
                }
            });
        });

        // Highlight active outline item on scroll (use the same heading set)
        let ticking = false;
        const OFFSET_TOP = 106;

        const updateActive = () => {
            let currentEl = null;
            for (let i = 0; i < outlinePairs.length; i++) {
                const top = outlinePairs[i].el.getBoundingClientRect().top;
                if (top <= OFFSET_TOP + 1) currentEl = outlinePairs[i].el; else break;
            }
            courseOutlineLinks.forEach(l => l.classList.remove('active'));
            (elToLinks.get(currentEl) || []).forEach(l => l.classList.add('active'));
            ticking = false;
        };

        document.addEventListener('scroll', () => {
            if (!ticking) {
                ticking = true;
                requestAnimationFrame(updateActive);
            }
        }, { passive: true });

        // Initial highlight
        updateActive();
    };

    // Run after DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initOutlineNav);
    } else {
        initOutlineNav();
    }
})();

// Toggle sidebar on mobile
if (document.querySelector('.mobile-sidebar')) {
    let sidebarToggle = document.querySelector('.mobile-sidebar .toggle');
    let sidebar = document.querySelector('.mobile-sidebar');
    sidebarToggle.addEventListener('click', function () {
        sidebar.classList.toggle('open');
    });
}
jQuery(document).ready(function ($) {
    // Page vars
    const $purchase_modal_trigger = $(".ncc-page-course_modal_toggle");
    const $purchase_modal = $("#ncc-page-course_modal");
    const $purchase_modal_content = $("#ncc-page-course_modal > .modal-content");
    const $purchase_modal_close = $("#ncc-page-course_modal_close");
    const $retake_modal_trigger = $(".ncc-page-retake_course_modal_toggle");
    const $retake_modal = $("#ncc-page-retake_course_modal");
    const $retake_modal_content = $("#ncc-page-retake_course_modal > .modal-content");
    const $retake_modal_close = $("#ncc-page-retake_course_modal_close");
    const $retake_modal_close_alt = $("#ncc-page-retake_course_modal_close_alt");
    const $modal_transition = 300; // Modal transition time in ms
    const $accordion = $(".dropdown-box__wrapper");
    const $accordion_head = $(".dropdown-box__title");
    const $accordion_content = $(".dropdown-box__content");

    // Show purchase modal
    $($purchase_modal_trigger).on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        $($purchase_modal).css("display", "flex").hide().fadeIn($modal_transition);
    });

    // Show retake course modal
    $($retake_modal_trigger).on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        $($retake_modal).css("display", "flex").hide().fadeIn($modal_transition);

        // Extra step: Populate the modal contents from page vars
        $('#ncc-reset-course-name').text($(this).data('course-name'));
    });

    // Hide purchase modal
    $($purchase_modal_close).on("click", function (e) {
        e.preventDefault();
        $($purchase_modal).hide();
    });

    // Hide retake course modal
    $($retake_modal_close).on("click", function (e) {
        e.preventDefault();
        $($retake_modal).hide();
    });
    $($retake_modal_close_alt).on("click", function (e) {
        e.preventDefault();
        $($retake_modal).hide();
    });

    // Hide modals when clicking outside of it
    $("body").on("click", function () {
        if ($($purchase_modal).is(":visible")) {
            $($purchase_modal).hide();
        }
        if ($($retake_modal).is(":visible")) {
            $($retake_modal).hide();
        }
    });

    // Prevent purchase modal from closing when clicking inside of it
    $($purchase_modal_content).on("click", function (e) {
        e.stopPropagation();
    });

    // Prevent retake course modal from closing when clicking inside of it
    $($retake_modal_content).on("click", function (e) {
        e.stopPropagation();
    });

    // Toggle dropdown box
    $($accordion_head).on("click", function () {
        // If trying to close an open section, return
        if ($(this).parent().hasClass('open')) {
            // Close all open dropdowns
            $($accordion).removeClass('open');
            $($accordion_content).slideUp('fast');
            return;
        }

        // Close all open dropdowns
        $($accordion).removeClass('open');
        $($accordion_content).slideUp('fast');
        $(this).parent().toggleClass('open');
        $(this).next().slideToggle('fast');
    });

    // Button: Reset Course Data
    $('#ncc-reset-button-accept').click(function () {

        let course_id = $(this).data('course-id');
        let course_name = $(this).data('course-name');
        let user_id = $(this).data('user-id');

        // Disable Reset button
        $('#ncc-reset-button-accept').prop('disabled', true);

        // Display loader
        $('#ncc-reset-loading-container').toggle("slide");

        // Call function to process course reset
        var data = {
            action: 'ncc_reset_course_data',
            user: user_id,
            course_id: course_id,
            course_name: course_name
        };

        // Handle response
        $.post(ajaxurl, data, function (response) {

            // Hide loader
            $('#ncc-reset-loading-container').fadeOut(300);

            if (response == false) { // Course data reset failed

                // Hide the reset button
                $('#ncc-reset-button-accept').toggle("slide");

                $('#ncc-reset-message-container').children('p').addClass("ncc-reset-failure");
                $('.ncc-reset-failure').text("We apologize. Something went wrong and we were unable to reset the data for this course. Please try again or contact support for more options.");
                $('#ncc-reset-message-container').toggle("slide");

            } else { // Course data reset succeeded

                // Hide the buttons
                $('#ncc-reset-button-accept').toggle("slide");
                $('#ncc-page-retake_course_modal_close_alt').toggle("slide");

                $('#ncc-reset-message-container').children('p').addClass("ncc-reset-success");
                $('.ncc-reset-success').text("Course data reset successfully! You will be redirected to your course automatically...");
                $('#ncc-reset-message-container').toggle("slide").delay(3000).fadeOut(1500);

                // Redirect to course
                window.location.replace(response);

            }
        });
    });

    if ($('.sidebar-inner').length) {
        const sidebar = document.querySelector('.sidebar-inner:not(.sticky-dummy)');
        const nccSticky = new NCCSticky(sidebar, {
            offsetTop: () => sidebar.classList.contains('sticky--offset') ? 106 : 0,
            offsetBottom: 10 + 28
        });

        // Get original height of course_outline
        const course_outline = document.querySelector('.sidebar .course-outline');
        const course_outline_content = document.querySelector('.sidebar .course-outline .course-outline__content');
        const original_outline_scroll_height = course_outline_content.scrollHeight;
        const original_outline_client_height = course_outline_content.clientHeight;

        // Adjust course outline max-height based on outline content height (checks if content has a scrollbar)
        if (!(original_outline_scroll_height > original_outline_client_height)) {
            course_outline.style.maxHeight = 'min-content';
            course_outline.parentNode.style.maxHeight = 'min-content';
            course_outline_content.style.maxHeight = 'min-content';
        }

        const course_outline_original_height = parseInt(getComputedStyle(course_outline).height);

        // Check if purchase block is present in sidebar
        const purchase_block = document.querySelector('.sidebar .purchase-block');

        // If purchase block present and course outline wrapper is taller than viewport, adjust course_outline height
        if (purchase_block && (original_outline_scroll_height > original_outline_client_height)) {
            //course_outline.style.height = (course_outline_original_height - parseInt(getComputedStyle(purchase_block).height) - 28) + 'px';
        }

        new SimpleBar(document.querySelector('.sidebar-inner:not(.sticky-dummy) .course-outline .course-outline__content'));
        new SimpleBar(document.querySelector('.mobile-sidebar .course-outline .course-outline__content'));

        //Use same logic from header to offset the sticky outline once the header is shown/hidden
        var $header = $('#masthead'),
            off_Top = 0,
            menuH = $header.outerHeight(),
            latestScroll = 0,
            $outline = $('.sidebar-inner:not(.sticky-dummy)').first();

        // Offset header by default on first load
        $outline.addClass('sticky--offset').removeClass('sticky--no-offset');

        if ($header.hasClass('sticky-header')) {
            $(window).scroll(function () {
                var current = $(this).scrollTop();

                if ($outline.css('bottom') == '28px') {
                    $outline.removeClass('sticky--offset').removeClass('sticky--no-offset');
                    return;
                }

                if (current > latestScroll && current > menuH + off_Top) {
                    $outline.removeClass('sticky--offset').addClass('sticky--no-offset');

                    // If purchase block preset and course outline wrapper is taller than viewport, adjust course_outline height
                    if (purchase_block && (original_outline_scroll_height > original_outline_client_height)) {
                        course_outline.style.setProperty('height', (course_outline_original_height + 78 - parseInt(getComputedStyle(purchase_block).height) - 28) + 'px', 'important');
                    }
                } else {
                    $outline.addClass('sticky--offset').removeClass('sticky--no-offset');

                    // If purchase block preset and course outline wrapper is taller than viewport, adjust course_outline height
                    if (purchase_block && (original_outline_scroll_height > original_outline_client_height)) {
                        course_outline.style.setProperty('height', (course_outline_original_height - parseInt(getComputedStyle(purchase_block).height) - 28) + 'px');
                    }
                }

                latestScroll = current;
            });
        }
    }
});